import { gql } from '@apollo/client';

export default class ReportTemplateMutation {
    static REPORT_TEMPLATE_CREATE = gql`
        mutation reportTemplateCreate(
            $name: String!
            $content: String!
            $query: String!
            $frequency: String!
            $timeScheduled: String!
        ) {
            reportTemplateCreate(
                input: {
                    name: $name
                    content: $content
                    query: $query
                    frequency: $frequency
                    timeScheduled: $timeScheduled
                }
            ) {
                success
            }
        }
    `;

    static REPORT_TEMPLATE_UPDATE = gql`
        mutation reportTemplateUpdate(
            $id: Int!
            $name: String
            $content: String
            $query: String
            $frequency: String
            $timeScheduled: String
        ) {
            reportTemplateUpdate(
                id: $id
                input: {
                    name: $name
                    content: $content
                    query: $query
                    frequency: $frequency
                    timeScheduled: $timeScheduled
                }
            ) {
                success
            }
        }
    `;

    static REPORT_TEMPLATE_REMOVE = gql`
        mutation reportTemplateRemove($id: Int!) {
            reportTemplateRemove(id: $id) {
                success
            }
        }
    `;

    static REPORT_TEMPLATE_USER_CREATE = gql`
        mutation reportTemplateUserCreate(
            $reportTemplateId: Int!
            $usersTableUserId: Int!
        ) {
            reportTemplateUserCreate(
                input: {
                    reportTemplateId: $reportTemplateId
                    usersTableUserId: $usersTableUserId
                }
            ) {
                success
            }
        }
    `;

    static REPORT_TEMPLATE_USER_REMOVE = gql`
        mutation reportTemplateUserRemove($id: Int!) {
            reportTemplateUserRemove(id: $id) {
                success
            }
        }
    `;
}
